import * as React from "react";
import { styled, ThemeProvider } from "styled-components";
import { genericInputFieldStyles, InputIconWrapper, InputWrapper, LabelWrapper, textInputThemes, ErrorMessage, } from "../../styles/sharedInputStyles";
import InputTooltip from "../InputTooltip";
import LeadIcons from "../LeadIcons";
import { Label } from "../Text";
const StyledInput = styled.input `
  ${genericInputFieldStyles}
`;
export const Input = React.memo(React.forwardRef(({ label, trailingIcon, leadingIcon, required, value, disabled, tooltip, tooltipPosition = "top-right", tooltipButtonTitle = "Toggle tooltip", state = "default", errorMessage = "", ...props }, inputRef) => {
    const themeVars = textInputThemes[state];
    const themeStateVars = {
        hasValue: !!value,
        hasTrailingIcon: !!trailingIcon,
        hasLeadingIcon: !!leadingIcon,
    };
    const iconColor = disabled
        ? themeVars.iconColor
        : themeStateVars.hasValue
            ? themeVars.placeholderNotShownIconColor
            : themeVars.iconColor;
    return (React.createElement(ThemeProvider, { theme: { vars: themeVars, state: themeStateVars } },
        React.createElement(LabelWrapper, null,
            React.createElement(Label, { label: label, required: required, size: "medium" },
                React.createElement(InputWrapper, null,
                    React.createElement(InputIconWrapper, null,
                        React.createElement(LeadIcons, { iconColor: iconColor, leadingIcon: leadingIcon, trailingIcon: trailingIcon },
                            React.createElement(StyledInput, { disabled: disabled, required: required, value: value, ref: inputRef, ...props }))),
                    tooltip && (React.createElement(InputTooltip, { text: tooltip, position: tooltipPosition, buttonTitle: tooltipButtonTitle })))),
            errorMessage && state === "error" ? (React.createElement(ErrorMessage, null, errorMessage)) : null)));
}));
export default Input;
//# sourceMappingURL=Input.js.map